import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// TS types
import { Area, IPlanList, IPlanList_Format } from '@redux/common';
// Redux
import { RootState } from '@redux/store';

// component
import TPlan from '@component/NormalTHSR/TPlan'; // 各項清單明細
import TDetailInfo from './subComponent/DetailInfo';
import TTagsBlock from './subComponent/TagsBlock';

// shared component
import LoadingIcon from '@svg/LoadingIcon'; // svg component
import Reload from '@svg/Reload';
import Loading from '@component/Common/loading';
import Modal from '@component/Common/Modal';
import SlideFooter from '@component/Common/SlideFooter';
import Dialog from '@component/Common/Dialog';

// styles
import '../CommonStyles/TPlans.scss';

// common function
import {
    getTHSRTripInfo,
    THSRClearStorage,
    checkLigBoxOrDialogDisplay,
    formatThsrQtyReqBody,
} from '@libs/core';
import { getCheckThsrQty, fetchDetailData, fetchLightBoxData } from '@libs/apiCall';
import { isMobile } from '@libs/globalVariables';
import onSubmit from './Common/onSubmit';

// plugin
import dayjs from 'dayjs';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

// redux actions
import {
    setTRestore,
    setTPickCalendar,
    setTMInfoShow,
    setTNowListData,
    setTNowListID,
    setTAllSessions,
    setTIsSubmitSuccess,
    setTDetailLoadingFail,
    setTDetailData,
    setTTempCalendarData,
    setTIsDetailLoading,
    setTIsSessionLoading,
    setTSessionLoadingFail,
    setTPickSession,
} from '@redux/NormalT/actions';
import { setTCurrentStep, setTHSROptsMOpen } from '@redux/THSR/actions';
import {
    setDetailFetchAllData,
    setDetailFetchMonths,
    setDetailFetchFailMsg,
} from '@redux/Common/actions';
import Informations from './subComponent/Informations';

interface ListPanelProps {
    // TODO: 有時間再定義
    isCrossell?: boolean;
}

const TListPanel: React.FC<ListPanelProps> = (props) => {
    const { isCrossell } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        DetailData,
        NowListID,
        MInfoShow,
        isSessionLoading,
        isDetailLoading,
        DetailLoadingFail,
        isSubmitSuccess,
    } = useSelector((state: RootState) => state.NormalT);
    const {
        isDisney,
        DetailFetchAllData,
        ETID,
        ListData,
        focusArea,
        DetailFetchMonths,
        DetailFetchFailMsg,
        isTDetailCrossLoading,
        VerificationStatus,
    } = useSelector((state: RootState) => state.Common);
    const { AdvanceTime }: IPlanList = ListData;
    const { THSROpenedPanel } = useSelector((state: RootState) => state.THSR);
    const store_THSR = useSelector((state: RootState) => state.THSR);
    const [renderLists, setRenderLists] = useState<IPlanList_Format[]>(null);
    const [totalIsInStock, setTotalIsInStock] = useState<boolean>(true); // 預設有貨，確認選取的品項後再更改狀態 // 原 api 中的 TotalIsInStock 已經移除，改用 IsForSale 來判斷
    const renderTags = useMemo(() => {
        if (DetailData) return DetailData.Tag;
    }, [DetailData]);

    const [dialogSwitch, setDialogSwitch] = useState<{ [key: string]: boolean }>({}); //Dialog-State object
    const [fetchLightBoxResult, setFetchLightBoxResult] = useState({}); //Fetch lightBox save result state

    // _start：迪士尼光箱開發區
    // TODO:迪士尼對話框光箱開發暫時設置的"假資料"，待後續等API完成，再行移除
    const lightBoxMockData: {
        [key: string]: {
            title?: string;
            content?: string;
        };
    }[] = [
        fetchLightBoxResult, //Fetch json
    ];
    const disneyLightBoxData = lightBoxMockData[0].disney;
    console.log('TDisneyLightBoxData', disneyLightBoxData);
    console.log('TFetchLightBoxResult!', fetchLightBoxResult);
    console.log('TDialogSwitch', dialogSwitch);
    // _END：迪士尼光箱開發區

    // Fetch LightBox object data
    useEffect(() => {
        const getLightBoxData = async () => {
            const getData = await fetchLightBoxData();
            const result = await getData.json();

            setFetchLightBoxResult(result);
        };

        getLightBoxData();
    }, []);

    // Dialog component switch object settings
    useEffect(() => {
        // 初始化 dialog state
        if (isDisney && !!disneyLightBoxData && Object.keys(disneyLightBoxData).length) {
            setDialogSwitch({
                disney: false, //迪士尼對話框光箱
            });
        }
    }, [fetchLightBoxResult]);

    useEffect(() => {
        if (!ListData || !store_THSR.THSRInitData) return;
        // 篩選出單程或來回的ProductItemListFormat
        const currentListFormat = getTHSRTripInfo(
            store_THSR.THSRInitData.ThsrTripInfos,
            THSROpenedPanel
        ).ProductItemListFormat;

        console.log('currentListFormat🐱', currentListFormat);
        setRenderLists(currentListFormat);

        if (!isMobile) {
            // PC初次載入頁面預選第一筆
            /***
             * M版不能先載入，因M版使用要點選方案(handleClickList)才會打API
             * ( handleClickList()有擋同ID觸發 )
             ***/
            dispatch(setTNowListID(currentListFormat[0].FormatID));
            dispatch(setTNowListData(currentListFormat[0]));
            setTotalIsInStock(currentListFormat[0].IsForSale);
            console.log('初次載入頁面預選第一筆!!');

            currentListFormat[0].EarliestBuyDay
                ? dispatch(
                      setTPickCalendar(
                          dayjs(currentListFormat[0].EarliestBuyDay).format('YYYY-MM-DD')
                      )
                  )
                : dispatch(setTPickCalendar(null));

            const fetchDetailProps = {
                ETID: ETID,
                EarliestBuyDay: currentListFormat[0].EarliestBuyDay,
                ExpectedUseDay: currentListFormat[0].ExpectedUseDay,
                FormatID: currentListFormat[0].FormatID,
                isTHSR: true,
                // DetailFetchMonths,
                context: {
                    DetailFetchAllData,
                    setDetailFetchAllData,
                    setDetailLoadingFail: setTDetailLoadingFail,
                    setDetailFetchFailMsg,
                    setDetailData: setTDetailData,
                    setTempCalendarData: setTTempCalendarData,
                    setIsDetailLoading: setTIsDetailLoading,
                    setPickCalendar: setTPickCalendar,
                    // setDetailFetchMonths,
                    ThsrRoundType: THSROpenedPanel,
                    // TODO:第二階段處理
                    setIsSessionLoading: setTIsSessionLoading,
                    setSessionLoadingFail: setTSessionLoadingFail,
                    setAllSessions: setTAllSessions,
                    setPickSession: setTPickSession,
                },
                dispatch,
            };

            if (currentListFormat[0].IsForSale) fetchDetailData(fetchDetailProps);
        }
    }, [ListData]);

    useEffect(() => {
        if (NowListID && focusArea === Area.Origin) {
            dispatch(setTRestore());
        }
    }, [focusArea]);

    // 自建TotalIsInStock狀態更改
    const changeTotalIsInStock = useCallback(
        (currentListTotal: boolean) => {
            if (totalIsInStock !== currentListTotal) setTotalIsInStock(currentListTotal);
        },
        [ListData]
    );

    const clickMSubmitBtn = () => {
        if (isSubmitSuccess) return false;
        if (!totalIsInStock) return false;
        // 送出前清空高鐵相關sessionStorage
        THSRClearStorage();

        let reqBody = formatThsrQtyReqBody(
            store_THSR.THSRDetailData.Rounds,
            ETID,
            store_THSR?.THSRDepartTrain,
            store_THSR?.THSRReturnTrain,
            store_THSR?.THSRInfo
        );

        //需驗證高鐵是否還有庫存
        getCheckThsrQty({
            context: store_THSR,
            req: reqBody,
        }).then(async (res) => {
            if (res.every((child) => child?.HasQty)) {
                //有庫存
                const isSuccess = await onSubmit('checkData');
                if (typeof isSuccess === 'undefined') return;
                if (isSuccess.selectChecked) {
                    // 確認是否為迪士尼產品
                    if (checkLigBoxOrDialogDisplay(dialogSwitch, setDialogSwitch, 'disney')) {
                        setDialogSwitch((prev) => {
                            prev.disney = true;
                            return { ...prev };
                        });
                    } else {
                        dispatch(setTIsSubmitSuccess(true));
                        onSubmit('redirect');
                    }
                } else if (
                    !isSuccess.selectChecked &&
                    'IsSuccess' in isSuccess.apiChecked &&
                    !isSuccess.apiChecked.IsSuccess
                ) {
                    // 驗價錯誤則顯示提示重整頁面光箱
                    setDialogSwitch((prev) => {
                        prev.verify = true;
                        return { ...prev };
                    });
                }
            } else {
                //無庫存or其他錯誤
                window.alert(t('THSR.index.noSeatErr', { symbol: '！' }));
                window.location.reload();
            }
        });
    };

    return (
        <div className="THSRBlock TnormalPlan">
            <div className="ActivityPanel">
                <div className="mainBLock">
                    <div className="optionsWrap">
                        <div className="optionTitleWrap">
                            <div className="subTitle">{t('THSR.index.choose_plan')}</div>
                        </div>
                        <div className="listWrap">
                            {renderLists && renderLists.length !== 0 ? (
                                renderLists.find((item) => item.FormatID === 'Default') ? ( //產品有無ID
                                    <TPlan
                                        data={renderLists[0]}
                                        key={renderLists[0].FormatID} //Default
                                        Currency={ListData.Currency}
                                        SaleCurrency={ListData.SaleCurrency}
                                        listIndex={0}
                                        changeTotalIsInStock={changeTotalIsInStock}
                                        isCrossell={isCrossell}
                                    />
                                ) : (
                                    renderLists.map((list: IPlanList_Format, index: number) => (
                                        <TPlan
                                            data={list}
                                            key={list.FormatID} //有ID產品，1個或多數
                                            Currency={ListData.Currency}
                                            SaleCurrency={ListData.SaleCurrency}
                                            listIndex={index}
                                            changeTotalIsInStock={changeTotalIsInStock}
                                            isCrossell={isCrossell}
                                        />
                                    ))
                                )
                            ) : (
                                <div>{t('common.noListFormat')}</div>
                            )}
                        </div>
                    </div>
                    {isDetailLoading || isTDetailCrossLoading ? (
                        <Loading icon={<LoadingIcon />} text={t('common.loading_project')} />
                    ) : DetailLoadingFail ? (
                        <div>
                            {DetailFetchFailMsg
                                ? t(`common.${DetailFetchFailMsg}`)
                                : t('common.defaultErrMsg')}
                        </div>
                    ) : (
                        <TDetailInfo
                            totalIsInStock={totalIsInStock}
                            dialogSwitch={dialogSwitch}
                            setDialogSwitch={setDialogSwitch}
                            isCrossell={isCrossell}
                        />
                    )}
                </div>
                {isMobile ? (
                    <Modal
                        isOpen={MInfoShow}
                        title={(() => {
                            const currentFormat = ListData?.Format?.filter(
                                (item) => item.FormatID === NowListID
                            );
                            return currentFormat ? currentFormat[0]?.FormatName : '';
                        })()}
                        onClose={(isShow) => dispatch(setTMInfoShow(isShow))}
                    >
                        {isDetailLoading || isTDetailCrossLoading ? (
                            <Loading icon={<LoadingIcon />} text={t('common.loading_project')} />
                        ) : DetailLoadingFail ? (
                            <div>
                                {DetailFetchFailMsg
                                    ? t(`common.${DetailFetchFailMsg}`)
                                    : t('common.defaultErrMsg')}
                            </div>
                        ) : (
                            !!DetailData && 
                                <>
                                    <TTagsBlock data={renderTags} />
                                    <Informations formatId={NowListID} />
                                </>
                        )}
                    </Modal>
                ) : (
                    !isDetailLoading && !!DetailData && 
                        <>
                            <TTagsBlock data={renderTags} />
                            <Informations formatId={NowListID} />
                        </>
                )}
                {isMobile && !isDetailLoading && !isSessionLoading && !DetailLoadingFail && (
                    <SlideFooter
                        hide={!NowListID || MInfoShow}
                        onClickLeftBtn={() => {
                            dispatch(setTHSROptsMOpen(false));
                            dispatch(setTCurrentStep(0));
                            dispatch(setTRestore());
                        }}
                        onClickRightBtn={async () => {
                            clickMSubmitBtn();
                        }}
                        leftBtnText={t('THSR.index.cancelAndResetTHSR')}
                        rightBtnClass={[
                            'planFoot',
                            {
                                disabled: isSubmitSuccess,
                                notReady: AdvanceTime.length > 0,
                                allsold: !totalIsInStock,
                            },
                        ]}
                        rightBtnJSX={
                            <div className={cx('confirm')}>
                                <div>
                                    {AdvanceTime.length > 0
                                        ? t('THSR.index.comingSoon')
                                        : totalIsInStock
                                        ? t('THSR.index.bookNow')
                                        : t('THSR.index.restocking')}
                                </div>
                                {isSubmitSuccess && (
                                    <div className="reload">
                                        <Reload color="#ffffff" />
                                    </div>
                                )}
                            </div>
                        }
                    />
                )}
            </div>
            {/* 迪士尼對話框光箱 */}
            <Dialog
                type="default"
                title={disneyLightBoxData?.title ?? ''}
                body={disneyLightBoxData?.content ?? ''}
                open={dialogSwitch.disney}
                onClose={() => {
                    console.log('Close Disney LightBox!');
                    dispatch(setTIsSubmitSuccess(false));
                    setDialogSwitch((prev) => {
                        prev.disney = false;
                        return { ...prev };
                    });
                }}
                // onCancel={() => {
                //     console.log('cancel!')
                //     console.log(dialogSwitch)
                //     setDialogSwitch(prev => {
                //         prev.disney = false;
                //         return {...prev};
                //     })
                // }}
                onOK={() => {
                    console.log('Disney CheckOK!');
                    dispatch(setTIsSubmitSuccess(true));
                    setDialogSwitch((prev) => {
                        prev.disney = false;
                        return { ...prev };
                    });
                    onSubmit('redirect');
                }}
                OKText={t('THSR.index.IHaveRead')}
                showCloseButton={true}
                className={cx('disney')}
            />
            {/* 驗價提示光箱 */}
            <Dialog
                type="default"
                title={VerificationStatus?.Title ?? ''}
                body={VerificationStatus?.ErrMessage ?? 'fetch API error, please reset page'}
                // body={"購買品項 成人 / 每人，購買數量：0<br>小於最低購買數量：1 <br>請重新選擇"}
                open={dialogSwitch.verify}
                onClose={() => {
                    console.log('Close Verify LightBox!');
                    dispatch(setTIsSubmitSuccess(false));
                    setDialogSwitch((prev) => {
                        prev.verify = false;
                        return { ...prev };
                    });
                }}
                onOK={() => {
                    // 按下已閱讀後重新整理頁面
                    console.log('validate error, reset detailPage...');
                    setDialogSwitch((prev) => {
                        prev.verify = false;
                        return { ...prev };
                    });
                    window.location.reload();
                }}
                OKText={t('THSR.index.IHaveRead')}
                showCloseButton={true}
                className={cx('orderValidity')}
            />
        </div>
    );
};

export default TListPanel;
